// extracted by mini-css-extract-plugin
export default {"list":"SigEventsList_list__dI1IS"};